import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

const galleryItems = [
  { src: '/images/gallery1.png', captionKey: 'galCap2', alt: 'Technician fitting exhaust muffler components' },
  { src: '/images/gallery2.png', captionKey: 'galCap3', alt: 'Welder fabricating custom exhaust pipe' },
  { src: '/images/gallery3.png', captionKey: 'galCap4', alt: 'Mechanic working on exhaust under a vehicle' },
];

export default function Gallery() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gallery-section sm-section" data-testid="build-gallery" ref={ref}>
      <div className="sm-container">
        <div className="reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)' } : {}}>
          <div className="section-label">{t.galleryLabel}</div>
          <h2 className="section-title">{t.galleryTitle}</h2>
          <p className="section-subtitle">{t.gallerySubtitle}</p>
        </div>
        <div className="gallery-grid">
          {galleryItems.map((item, i) => (
            <div key={i} className="reveal-item" style={{ transitionDelay: `${i * 60}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
              <div className="gallery-item">
                <img src={item.src} alt={item.alt} loading="lazy" />
              </div>
              <p className="gallery-caption">{t[item.captionKey]}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
